import { queryState, updateState, importState } from "./creator";

export const queriedClasses = queryState.selector;

export const updateClassObj = updateState.selector;

export const importClassesObj = importState.selector;
